import { render } from "./RatingCardLoading.vue?vue&type=template&id=f7a66a6a"
const script = {}

const cssModules = {}
import style0 from "./RatingCardLoading.vue?vue&type=style&index=0&id=f7a66a6a&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__